import { memberDataState } from '../../../modules/store/accountPersistentStore';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLevelTypeFromStore = (sessionData: any, memberData: memberDataState | null) => {
  return (
    memberData?.customer?.loyaltyInformation?.rewards?.levelType?.code ||
    sessionData?.customer?.loyaltyInformation?.rewards?.levelType?.code
  );
};

export { useWalletWidgetTierColor } from './useWalletWidgetTierColor';
export { resolveTierIconColor } from './resolveTierIconColor';
